<template>
  <div>
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="合同编号:" prop="contractNum">
        <el-input v-model.trim="searchForm.contractNum" placeholder="请输入合同编号" />
      </el-form-item>
      <el-form-item label="项目名称:" prop="projectName">
        <el-input v-model.trim="searchForm.projectName" placeholder="请输入项目名称" />
      </el-form-item>
      <el-form-item label="代理商名称:" prop="orderUnit">
        <el-input v-model.trim="searchForm.orderUnit" placeholder="请输入代理商名称" />
      </el-form-item>
      <el-form-item label="部门:" prop="departmentName">
        <el-input v-model.trim="searchForm.departmentName" placeholder="请输入部门" />
      </el-form-item>
      <el-form-item label="区域:" prop="regionName">
        <el-input v-model.trim="searchForm.regionName" placeholder="请输入区域" />
      </el-form-item>
      <el-form-item label="申请人:" prop="applicationName">
        <el-input v-model.trim="searchForm.applicationName" placeholder="请输入申请人" />
      </el-form-item>
      <el-form-item label="申请时间:" prop="createBeginTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createBeginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              @change="handleChangeStartTime"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="isLoading" @click="handleSearch">
          搜索
        </el-button>
        <el-button type="default" @click="handleRest">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <div class="tableBody">
      <el-table v-loading="isLoading" :data="tableData" border style="width: 100%">
        <el-table-column prop="contractNum" label="合同编号" align="left" min-width="150" fixed="left" />
        <el-table-column prop="projectName" label="项目名称" align="left" min-width="150" />
        <el-table-column prop="orderUnit" label="代理商名称" align="left" min-width="150" />
        <el-table-column prop="assignAndRatio" label="已分配金额/比例" align="right" min-width="150" header-align="left" />
        <el-table-column prop="assignAmount" label="申请撤销金额" align="right" min-width="150" header-align="left" />
        <el-table-column prop="departmentName" label="部门" align="left" min-width="150" />
        <el-table-column prop="regionName" label="区域" align="left" min-width="150" />
        <el-table-column prop="applicationName" label="申请人" align="left" min-width="150" />
        <el-table-column prop="applicationTime" label="申请时间" align="left" min-width="150" />
        <el-table-column prop="state" label="当前状态" align="left" min-width="150" />
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="pageState.pageSize"
          :current-page.sync="pageState.pageIndex"
          layout="total, prev, pager, next, jumper,sizes"
          :total="pageState.total"
          hide-on-single-page
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { revokeAssignRecordPage } from '@/API/international';

export default {
  name: 'ViewRevocationRecords',
  props: {
    tabsActive: {
      type: String,
      default: ''
    }
  },
  computed: {
    tabActive () {
      return this.tabsActive;
    }
  },
  data () {
    return {
      pageState: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      searchForm: {
        contractNum: '',
        projectName: '',
        orderUnit: '',
        departmentName: '',
        regionName: '',
        applicationName: '',
        createBeginTime: '',
        createEndTime: ''
      },
      tableLoading: false,
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.createBeginTime) {
            let date = new Date(this.searchForm.createBeginTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      isLoading: false
    };
  },
  methods: {
    handleSizeChange (size) {
      this.pageState.pageSize = size;
      this.handleSearch();
    },
    handleCurrentChange (index) {
      this.pageState.pageIndex = index;
      this.handleSearch();
    },
    handleChangeStartTime (time) {
      // 如果 第一个时间大于第二个时间 那么直接清空第二个时间
      if (dayjs(time).isAfter(dayjs(this.searchForm.createEndTime))) {
        this.searchForm.createEndTime = '';
      }
    },
    handleSearch () {
      this.isLoading = true;
      // 为什么不用解构的形式， 因为在编辑器中会有下划线
      const params = {
        pageSize: this.pageState.pageSize,
        pageIndex: this.pageState.pageIndex,
        contractNum: this.searchForm.contractNum,
        projectName: this.searchForm.projectName,
        orderUnit: this.searchForm.orderUnit,
        departmentName: this.searchForm.departmentName,
        regionName: this.searchForm.regionName,
        applicationName: this.searchForm.applicationName,
        createBeginTime: this.searchForm.createBeginTime,
        createEndTime: this.searchForm.createEndTime
      };
      revokeAssignRecordPage(params).then((res) => {
        let json = res.data;
        if (Number(json.status) === 200) {
          this.tableData = json.data.list || [];
          this.pageState.total = json.data.total || 0;
        }
      }).catch((e) => {
        console.log(e);
      }).finally(() => {
        this.isLoading = false;
      });
    },
    handleRest () {
      this.$refs.searchForm.resetFields();
      this.searchForm.createEndTime = '';
      this.pageState.pageSize = 10;
      this.pageState.pageIndex = 1;
      this.handleSearch();
    }
  },
  watch: {
    tabActive (val) {
      if (val === '10') {
        this.handleSearch();
      }
    }
  },
  mounted () {
    this.handleSearch();
  }
};
</script>

<style scoped lang="scss">

</style>
